import ChatBubbleContext from '@components/DevRev/SupportBubbleContext';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle
} from '@mui/material';
import { getLimitDetails } from '@utils/limits';
import React, { useCallback } from 'react';
import { IChatBubbleContext } from 'types/devRev';
import { LimitType } from 'types/limits';

const LimitsExceededDialog = ({
	limitType,
	onCancel
}: {
	limitType: LimitType;
	onCancel: () => void;
}) => {
	const { open } = React.useContext<IChatBubbleContext>(ChatBubbleContext);
	const { text, title } = getLimitDetails(limitType);

	const onContact = useCallback(() => {
		onCancel();
		open();
	}, [open, onCancel]);
	return (
		<Dialog open maxWidth="xs" disableRestoreFocus data-testid="limits-dialog">
			<DialogTitle color="error">{intl.tr(title)}</DialogTitle>
			<DialogContent>{intl.tr(text)}</DialogContent>
			<DialogActions>
				<Button
					onClick={onCancel}
					variant="text"
					data-testid="limits-dismiss-button"
				>
					{intl.tr('button.dismiss')}
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={onContact}
					data-testid="contact-us-button"
				>
					{intl.tr('project.notifications.dialog.contact.us')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default LimitsExceededDialog;
